import { validatePresence } from 'ember-changeset-validations/validators';

export default {
  commitmentDate: validatePresence({
    presence: true,
    message: "Commitment Date can't be blank",
  }),
};
